import { ActionTree } from "vuex";
import { State } from "./state";
import { create, filter, findOne, update, findAll } from "@/store/Crud/functions/actions";
import { IS_LOADING, SET_ERROR, SET_DATA_ITEM, SET_DATA_LIST, SET_SUCCESS, SET_TUEV_SYSTEMS, SET_TUEV_STUDENTS } from "./types";
import axios from "@/utils/axios";
import { AxiosError, AxiosResponse } from "axios";
import { Vue } from "vue-property-decorator";
import i18n from "@/i18n";

const URL = "/testing-organizations";

export const syncTestingOrganizationStudents = async (store: any, options: any): Promise<any> => {
  store.commit(IS_LOADING, true);
  return await axios
    .post(`${URL}/students/sync/${options.tuevSystem.toLowerCase()}`)
    .then(({ data }) => {
      store.commit(IS_LOADING, false);
      store.commit(SET_DATA_ITEM, data);
    })
    .catch(({ response }) => {
      store.commit(IS_LOADING, false);
      store.commit(SET_ERROR, response.data);
    });
};

export const findTestingOrganizationStudents = async (store: any, options: any): Promise<any> => {
  store.commit(IS_LOADING, true);
  return await axios
    .get(`${URL}/students/${options.tuevSystem?.toLowerCase()}?match=true`)
    .then(({ data }) => {
      store.commit(IS_LOADING, false);
      store.commit(SET_TUEV_STUDENTS, data);
    })
    .catch(({ response }) => {
      store.commit(IS_LOADING, false);
      store.commit(SET_ERROR, response.data);
    });
};

export const findTestingOrganizationStudentsNoMatch = async (store: any, options: any): Promise<any> => {
  store.commit(IS_LOADING, true);
  return await axios
    .get(`${URL}/students/${options.tuevSystem?.toLowerCase()}?match=false`)
    .then(({ data }) => {
      store.commit(IS_LOADING, false);
      store.commit(SET_TUEV_STUDENTS, data);
    })
    .catch(({ response }) => {
      store.commit(IS_LOADING, false);
      store.commit(SET_ERROR, response.data);
    });
};

export const saveStudentList = async (store: any, data: any): Promise<any> => {
  store.commit(IS_LOADING, true);
  return await axios
    .post(`${URL}/students/save`, data)
    .then(({ data }) => {
      store.commit(IS_LOADING, false);
      store.commit(SET_DATA_ITEM, data);
      return true;
    })
    .catch(({ response }) => {
      store.commit(IS_LOADING, false);
      store.commit(SET_ERROR, response.data);
    });
};

export const deleteTestingOrganizationStudentPermanently = async (store: any, studentId: any): Promise<any> => {
  store.commit(IS_LOADING, true);
  return await axios
    .delete(`${URL}/students/delete/${studentId}`)
    .then(({ data }) => {
      store.commit(IS_LOADING, false);
      return true;
    })
    .catch(({ response }) => {
      store.commit(IS_LOADING, false);
      store.commit(SET_ERROR, response.data);
      return true;
    });
};

// FOR TESTING PURPOSES ONLY - DO NOT USE
export const deleteStudentList = async (store: any): Promise<any> => {
  store.commit(IS_LOADING, true);
  return await axios
    .delete(`${URL}/students/delete`)
    .then(({ data }) => {
      store.commit(IS_LOADING, false);
      store.commit(SET_DATA_ITEM, data);
    })
    .catch(({ response }) => {
      store.commit(IS_LOADING, false);
      store.commit(SET_ERROR, response.data);
    });
};

export const archiveTestOrganization = async (store: any, options: any): Promise<void> => {
  store.commit(IS_LOADING, true);
  return await axios
    .post(`${URL}/archive?id=${options.id}&archived=${options.archived}`)
    .then(({ data }) => {
      store.commit(IS_LOADING, false);
      store.commit(SET_DATA_ITEM, data);
    })
    .catch(({ response }) => {
      store.commit(IS_LOADING, false);
      store.commit(SET_ERROR, response.data);
    });
};

export const findAllTuevSystems = async (store: any, options: any): Promise<void> => {
  store.commit(IS_LOADING, true);
  store.commit(SET_TUEV_SYSTEMS, []);
  return await axios
    .get(`${URL}/systems`)
    .then(({ data }) => {
      store.commit(IS_LOADING, false);
      store.commit(SET_TUEV_SYSTEMS, data);
    })
    .catch((error: AxiosError) => {
      store.commit(IS_LOADING, false);
      store.commit(SET_TUEV_SYSTEMS, []);
    });
};

export default <ActionTree<State, any>>{
  filter,
  create,
  findOne,
  update,
  findAll,
  archiveTestOrganization,
  findAllTuevSystems,
  syncTestingOrganizationStudents,
  findTestingOrganizationStudents,
  deleteTestingOrganizationStudentPermanently,
  findTestingOrganizationStudentsNoMatch,
  saveStudentList,
  deleteStudentList,
};
